import Axios from '@/plugins/axios';
import '@/plugins/icons';
import '@/plugins/lazysizes';
import '@/plugins/svg';

export default () => {
    Axios.init();
};
